const developerIdToRenewalLinkMap : Record<string, string> = {
  'zarfatiZvi': 'company/צרפתי-צבי-ובניו/',
  'PinuiBinuiOrgIl': 'company/ע-ט-החברה-להתחדשות-עירונית/',
  'kidmat-yovel': 'company/קדמת-היובל/',
  'avney-derech': 'company/אבני-דרך-י-י-בעמ/',
  'pelenadlan': 'company/פלא-יזמות-נדלן-בעמ/',
  'kete': 'company/קטה-יזמות-בניה-והשקעות/',
  'boh': 'company/בוני-התיכון/',
  'MnG-Group': 'company/קבוצת-mng/',
  'levinstein': 'company/קבוצת-לוינשטין/',
  'avisror': 'company/אביסרור-משה-ובניו/',
  'carasso': 'company/קרסו-נדלן-בעמ/',
  'ashtrom': 'company/אשטרום-מגורים/',
  'Africa38': 'company/אפריקה-התחדשות-עירונית/',
  'acroGroup': 'company/קבוצת-אקרו/',
  'aura': 'company/אאורה-מחדשים-את-ישראל/',
  'RAMOT_IN_THE_CITY_MOFET': 'company/רמות-בעיר-בע״מ/',
  'ICR': 'company/icr-ישראל-קנדה-ראם-מגורים-בעמ/',
  'city-people': 'company/אנשי-העיר-מקבוצת-רוטשטיין/',
  'avgad': 'company/קבוצת-אב-גד-5/',
  'ainav': 'company/ענב/',
  'terra': 'company/טרא-נדלן-ויזמות-בעמ/',
  'cnaan': 'company/קבוצת-כנען/',
  'bendavidgroup': 'company/קבוצת-בן-דוד/',
  'dimri': 'company/י-ח-דמרי-בניה-ופיתוח-בעמ/',
  'ken-hator': 'company/קן-התור-התחדשות-עירונית/',
  'Aviv_Yizum': 'company/אביב-מליסרון-בעמ/',
  'redSeeGroup': 'company/ים-סוף-נדלן-מקבוצת-פפושדו/',
  'dunietz': 'company/קבוצת-דוניץ-אלעד/',
  'BaitYerushalmi': 'company/קבוצת-בית-ירושלמי/',
  'grofit': 'company/גרופית-הנדסה-אזרחית-ועבודות-ציבוריות/',
  'zhg': 'company/צמח-המרמן-בעמ/',
  'maozdaniel': 'company/מעוז-דניאל-חברה-קבלנית-לבניה-בעמ/',
  'shemiAchzakot': 'company/שמי-בנייה-ייזום-והתחדשות-עירונית/',
  'gabaiGroup': 'company/קבוצת-גבאי/',
  'yeshuv': 'company/הכשרת-היישוב/',
  'rotshtein': 'company/רוטשטיין-נדלן-בעמ/',
  'shb': 'company/שיכון-ובינוי-נדלן-2/',
  'ZIM_BAHARI': 'company/צים-בהרי-נדלן/',
  'azorim': 'company/824/',
  'yovalim': 'company/קבוצת-יובלים/',
  'raykgroup': 'company/קבוצת-רייק/',
  'almog_renew': 'company/אלמוג-פינוי-בינוי/',
  'baitvegag': 'company/בית-וגג/',
  'Kim%20Lustigman%20Development%20and%20Construction%20Ltd': 'company/קים-לוסטיגמן-יזום-ובנייה-בעמ/',
  'arazim': 'company/אורון-נדלן-מקבוצת-אורון-אחזקות-והשקעו/',
  'maslavi': 'company/מצלאוי-חברה-לבניין-בעמ/',
  'renovo': 'company/רינובו-מגורים-4/',
  'OfekHoldings': 'company/קבוצת-אופק-אחזקות-התחדשות-עירונית-בע/',
  'AadlerAssets': 'company/א-אדלר-נכסים-בעמ/',
  'KATA_HOLDINGSLTD': 'company/kata-group/',
  'engelinvest38': 'company/אנגלאינווסט/',
  'kedar-mivnim': 'company/קידר-מבנים-4/',
  'ecocity': 'company/אקו-סיטי/',
  'YahazBniya': 'company/יעז-יזמנות-ובניה/',
  'YesodotShitofLTD': 'company/קבוצת-קאהן/',
  'city_project_yazamut_hithadshut': 'company/סיטי-פרוייקטים/',
  'Krinsky-Gottlieb': 'company/קרינסקי-גוטליב/',
  'hkr': 'company/קבוצת-ה-ק-ר-בעמ/',
  'broshnir': 'company/קבוצת-brosh/',
  'yoshfeYakar': 'company/קבוצת-יושפה/',
  'DRafaelConcstructionLtd': 'company/ד-רפאל/',
  'Aviv38BniaVeNechasim': 'company/אביב-38-בניה-ונכסים-בעמ/',
  'shalom-nathan': 'company/קבוצת-שלום-את-נתן/',
  'yanuv': 'company/ינוב-בניה-ופיתוח-בעמ/',
  'benshalomyehosua': 'company/בן-שלום-יזמות-ובנייה/',
  'NEW_ERA': 'company/ניו-ארה-יזמות-נדלן-וניהול-פרויקטים-בע/',
  'tb-nadlan': 'company/טובול-ברוקס-דניאל/',
  'CIBrosInvestRELtd': 'company/אחים-כ-י-השקעות-בנדלן-בעמ/',
  'DanielProjectsNIDLtd': 'company/דניאל-פרויקטים-נ-י-ד-בע״מ/',
  'rothschild-group': 'company/קבוצת-צליח-רוטשילד/',
  'meshulmiBulding': 'company/בנייני-משולמי-בעמ/',
  'sgin': 'company/שדות-גיטלמן/',
  'MotagIroni': 'company/מותג-עירוני/',
  'oracle-re': 'company/אוראקל-יזמות-נדלן-בעמ/',
  'Shatban': 'company/שטבן-בעמ/',
  'ram-bair': 'company/רם-מוגרבי-ארדיטי/',
  'EwaveNadlan': 'company/ewave-nadlan/',
  'newnetanya': 'company/החברה-להתחדשות-נתניה/',
  'LiRanEntInvConstLtd': 'company/קבוצת-אשלי-לירן/',
  'neve': 'company/נכסים-ובניין-מגורים-נוה/',
  'MivnimHizokHidosh': 'company/קבוצת-מבנים/',
  'eshetsorin': 'company/עשת-סורין-יזום-ובניה-בעמ/',
  'ShagLoolLtd': 'company/ש-א-ג-ולול-בעמ/',
  'TCI38': 'company/איתנים-148/',
  'pinui-binui.com': 'company/א-ש-חידוש-ובינוי-נדלן-בעמ/',
  'bnoRE': 'company/בינו-נדלן-קידום-יזום-וניהול-פרוייקטים/',
  'hagagGroup': 'company/קבוצת-חגג/',
  'fridmanCharsori': 'company/שינבר-חירות-השקעות-בעמ/',
  'libatower': 'company/ל-י-ב-א-טאואר-יזמות-ובנייה-בעמ/',
  'admonSarfati': 'company/אדמון-ל-צרפתי-בעמ/',
  'misharsr': 'company/מישר-ש-ר-יזמות-בעמ/',
  'YesodNadlan': 'company/yesod/',
  'talnirg': 'company/קבוצת-טלינר-יזמות-וניהול-פרויקטים-בעמ/',
  'KMSHECHTERLTD': 'company/שכטר-נדלן/',
  'CPSL38investments': 'architect/cpsl/',
};

export const getUrbanRenewalLink = (developerId: string) => {
  if (developerId in developerIdToRenewalLinkMap) {
    return `https://madadithadshut.co.il/${developerIdToRenewalLinkMap[developerId]}`;
  }
  return null;
};
